import React, { createContext, useContext, useReducer } from 'react';

const CartContext = createContext<any | null>(null);

export const useCart = () => useContext(CartContext);

const initialState = { items: [] };

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CART':
      return action.payload || { items: [] };
    case 'ADD_ITEM':
      return { ...state, items: [...state.items, action.payload] };
    case 'REMOVE_ITEM':
      return { ...state, items: state.items.filter(item => item.id !== action.payload) };
    case 'REMOVE_CART':
      return { items: [] };
    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, initialState);


  const addToCart = product => {
    console.log('addToCart', cart);

    addItemToCart(product);
  };

  const addItemToCart = product => {
    try {
      const newItem = {
        id: product.id + '_' + Date.now(),
        ...product
      };
      dispatch({ type: 'ADD_ITEM', payload: newItem });
    } catch (error) {
      console.error('Error adding item to cart:', error);
    }
  };

  const addItemToUserCart = product => {
    try {
      const newItem = {
        id: product.id + '_' + Date.now(),
        ...product
      };
      dispatch({ type: 'ADD_ITEM', payload: newItem });
    } catch (error) {
      console.error('Error adding item to user cart:', error);
    }
  };

  const removeItemFromCart = (cartItemId) => {
    try {
      dispatch({ type: 'REMOVE_ITEM', payload: cartItemId });
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  };

  const removeCart = (cartId) => {
    try {
      dispatch({ type: 'REMOVE_CART', payload: null });
    } catch (error) {
      console.error('Error removing all items from cart:', error);
    }
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeItemFromCart,
        removeCart,
        addItemToUserCart,
        addItemToCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
